// extracted by mini-css-extract-plugin
module.exports = {"navbar":"panelNavbar_navbar__2HZ29","toggle":"panelNavbar_toggle__12UpV","logo":"panelNavbar_logo__3A0hT","dropdown-menu":"panelNavbar_dropdown-menu__1i8JG"};